"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EligibleAddonsContainer;
var _react = _interopRequireWildcard(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _reactRedux = require("react-redux");
var _EligibleAddonsListing = _interopRequireDefault(require("./EligibleAddonsListing"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _reactRouterDom = require("react-router-dom");
var _r10CommonComponents = require("r10-common-components");
var _QuickFilters = _interopRequireDefault(require("./QuickFilters"));
var _Actions = require("../../actions/Actions");
var _selector = require("../../selectors/selector");
var _useTranslation = _interopRequireDefault(require("../../hooks/useTranslation"));
var _extractAddonsData = _interopRequireDefault(require("../../utils/extractAddonsData"));
var _useProps2 = _interopRequireDefault(require("../../hooks/useProps"));
var _useConfig2 = _interopRequireDefault(require("../../hooks/useConfig"));
var _appConstants = require("../../appConstants");
var _updateModeParam = _interopRequireDefault(require("../../utils/updateModeParam"));
var _setIdWithinQueryParam = _interopRequireDefault(require("../../utils/setIdWithinQueryParam"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Div = _styledComponents.default.div((0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin: auto;\n  max-width: 1030px;\n  @media only screen and (max-width: 766px) {\n    max-width: 330px;\n  }\n  @media only screen and (min-width: 767px) and (max-width: 1116px) {\n    max-width: 680px;\n  }\n\n  & > div {\n    padding: 0;\n  }\n"]))));
var LoaderWrapper = _styledComponents.default.div((0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 50vh;\n"]))));
function EligibleAddonsContainer() {
  var t = (0, _useTranslation.default)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouterDom.useHistory)();
  var _useProps = (0, _useProps2.default)(),
    eligibleAddonKeys = _useProps.eligibleAddonCardMappingConfiguration;
  var _useConfig = (0, _useConfig2.default)(),
    queryParam = _useConfig.queryParam,
    customerMSISDNId = _useConfig.customerMSISDNPlaceholderInQueryParam,
    showActiveAddonsButton = _useConfig.showActiveAddonsButton;
  var productId = (0, _reactRedux.useSelector)(_selector.getProductId);
  var eligibleAddonsData = (0, _reactRedux.useSelector)(_selector.eligibleAddons);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedFilters = _useState2[0],
    setSelectedFilters = _useState2[1];
  var isLoading = eligibleAddonsData.isLoading,
    failureError = eligibleAddonsData.error;
  var categories = new _extractAddonsData.default(eligibleAddonsData.addons, eligibleAddonKeys).getCategories();
  var filters = categories.map(function (c) {
    return {
      id: c,
      title: t(c),
      value: c
    };
  });
  var fetchAddons = function fetchAddons() {
    var queryParamWithId = (0, _setIdWithinQueryParam.default)(queryParam, customerMSISDNId, productId);
    dispatch((0, _Actions.fetchEligibleAddons)(queryParamWithId));
  };
  (0, _react.useEffect)(function () {
    dispatch((0, _Actions.clearEligibleAddons)());
    fetchAddons();
    dispatch((0, _Actions.sendTags)({
      taggingId: 'CUSTOMER_DASHBOARD_ADDONS_3',
      taggingType: 'view',
      taggingValue: {}
    }));
  }, []);
  var setMode = function setMode() {
    (0, _updateModeParam.default)(history, _appConstants.MODES.active);
  };
  var renderContent = function renderContent() {
    var doAddonsExist = !!Object.keys(eligibleAddonsData.addons).length;
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 5
      }
    }, /*#__PURE__*/_react.default.createElement(Div, {
      "data-testid": "container-wrapper"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, (doAddonsExist || failureError) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      justify: "between"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
      size: 2,
      weight: 3,
      text: t('buyAddons')
    })), showActiveAddonsButton && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
      col: 'auto',
      alignSelf: "center"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      justify: "center",
      noGutters: true
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
      onClick: setMode,
      text: t('activeAddons'),
      icon: {
        name: 'add-ons',
        justify: 'right'
      },
      dataAttributes: {
        'data-testid': 'active-addons-link'
      }
    })))), failureError ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      marginTop: 7,
      justify: "center"
    }, /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "error"
    }, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ErrorContent, {
      icon: "warning",
      title: t('somethingWentWrong'),
      description: t('somethingWentWrongDescription'),
      buttonText: t('retryButton'),
      iconSize: 1,
      buttonAction: function buttonAction() {
        return fetchAddons();
      }
    }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, filters.length > 1 ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      marginTop: 7,
      marginBottom: 7,
      noGutters: true
    }, /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "quick-filters"
    }, /*#__PURE__*/_react.default.createElement(_QuickFilters.default, {
      filters: filters,
      setSelectedFilters: setSelectedFilters
    }))) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        bottom: 7
      }
    }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      align: "center",
      justify: "between",
      noGutters: true
    }, /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": "addon-list"
    }, /*#__PURE__*/_react.default.createElement(_EligibleAddonsListing.default, {
      selectedFilters: selectedFilters
    })))))));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isLoading ? /*#__PURE__*/_react.default.createElement(LoaderWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    text: t('loading'),
    appearance: "primary",
    size: 2,
    dataAttributes: {
      'data-testid': 'loader-wrapper'
    }
  })) : renderContent());
}